export enum EPeopleField {
  Followers = 'followers',
  Followings = 'followings',
  Connections = 'connections',
}
